<template>
  <aside>
    <ul class="menu-list">
      <li v-for="(item, index) in items" :key="index" class="menu-item">
        <button :id="item.name" @mousedown.prevent="dragStart($event, item)">
          <icon :name="item.icon" :color="item.iconColor" scale=1.5 />
        </button>
        <span class="item-label">{{ item.label }}</span>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data(){
    return {
      items: [
        { name: 'start-event', clazz: 'startEvent', label: 'Start Event', icon: 'play-circle', iconColor: 'hsl(154, 64%, 49%)' },
        { name: 'user-task', clazz: 'userTask', label: 'User Task', icon: 'user', iconColor: 'hsl(235, 71%, 65%)'},
        { name: 'script-task', clazz: 'scriptTask', label: 'Script Task', icon: 'terminal', iconColor: 'hsl(218, 54%, 20%)' },
        { name: 'decision', clazz: 'decision', label: 'Decision', icon: 'check-circle', iconColor: 'hsl(11, 96%, 62%)' },
        { name: 'mail-task', clazz: 'mailTask', label: 'Mail Task', icon: 'at', iconColor: 'hsl(220, 54%, 65%)' },
        { name: 'update-record', clazz: 'updateRecord', label: 'Update Record', icon: 'edit', iconColor: 'hsl(189, 87%, 50%)' },
        { name: 'end-event', clazz: 'endEvent', label: 'End Event', icon: 'stop-circle', iconColor: 'hsl(348, 91%, 59%)' },
        { name: 'comment', clazz: 'comment', label: 'Comment', icon: 'comment', iconColor: 'hsl(188, 78%, 41%)'}
      ],
    }
  },
  computed: {

  },
  methods: {
    ...mapMutations('diagramBuilder', [
      'addNode',
      'updateCounter',
      'setCurrentNode'
    ]),
    dragStart(event, item) {
      let that = this
      
      document.addEventListener('mousemove', function(event) {
        rect.setAttribute('x', event.offsetX)
        rect.setAttribute('y', event.offsetY)
      })

      /* init a new node of the corresponding class */
      function initNode(event) {
        rect.style.visibility = 'hidden'

        const node = { 
          id: 'node' + +new Date,
          x: event.offsetX,
          y: event.offsetY,
          height: 40,
          width: 100,
          clazz: item.clazz,
          label: item.label,
          className: item.name,
          icon: {name: item.icon, color: item.iconColor},
          attachment: {}
        }
        
        that.addNode(node)
        that.updateCounter()
      }

      const rect = document.querySelector('rect#drag-node')

      if (rect) {
        rect.style.visibility = 'visible'
        document.addEventListener('mouseup', initNode, {once: true})
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  aside{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #ffffff;
  }
  ul{
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  li{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
    margin-top: 1rem;
    button{ 
      border: 1px solid transparent;
    }
    button:hover{
      border: 1px solid hsl(0, 0%, 88%);
    }
  }
  .icon{
    width: 36px;
    height: 36px;
  }
  .item-label{
    font-size: 13px;
  }
</style>